export var getTranslationDefaultFunction = function (_a) {
    var environmentLabel = _a.environmentLabel;
    return function (key) {
        throw new Error("It is not possible to translate ".concat(key, ". Translate function was not passed to the ").concat(environmentLabel));
    };
};
//# sourceMappingURL=translationDefaultFunction.js.map